import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { InventoryLayout } from '../components/inventory/InventoryLayout';
import { CheckCircle2, Mail, Phone, MapPin, Lock } from 'lucide-react';
import { FormSelect } from '../components/FormSelect';
import { inventoryCategories } from '../data/inventory';
export function ContactPage() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    jobTitle: '',
    orgName: '',
    orgType: '',
    country: '',
    city: '',
    enquiryType: '',
    productCategory: '',
    quantity: '',
    timescale: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };
  return <InventoryLayout data-id="element-265">
      {/* Page Header */}
      <div className="bg-navy-900 py-12 sm:py-16 border-b border-white/10" data-id="element-266">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-267">
          <div className="border-l-4 border-cg-orange-600 pl-6" data-id="element-268">
            <span className="text-sm font-bold uppercase tracking-[0.2em] text-cg-orange-600 block mb-3" data-id="element-269">
              Get in Touch
            </span>
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight max-w-4xl" data-id="element-270">
              Contact &amp; Support
            </h1>
            <p className="text-lg text-steel-300 max-w-3xl leading-relaxed" data-id="element-271">
              Our team is available to discuss product enquiries, order
              requests, and procurement requirements.
            </p>
          </div>
        </div>
      </div>

      <section className="bg-white py-16 sm:py-24" data-id="element-272">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-273">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16" data-id="element-274">
            {/* Contact Info */}
            <div className="lg:col-span-1" data-id="element-275">
              <h2 className="text-2xl font-bold text-navy-900 mb-8" data-id="element-276">
                Contact Information
              </h2>
              <div className="space-y-8" data-id="element-277">
                <div className="flex items-start gap-4" data-id="element-278">
                  <div className="w-10 h-10 bg-slate-50 border border-steel-200 flex items-center justify-center rounded-sm flex-shrink-0" data-id="element-279">
                    <Mail className="w-5 h-5 text-cg-orange-600" data-id="element-280" />
                  </div>
                  <div data-id="element-281">
                    <h3 className="text-sm font-bold text-navy-900 uppercase tracking-wider mb-1" data-id="element-282">
                      Email
                    </h3>
                    <p className="text-steel-600" data-id="element-283">orders@chilternglobal.com</p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-284">
                  <div className="w-10 h-10 bg-slate-50 border border-steel-200 flex items-center justify-center rounded-sm flex-shrink-0" data-id="element-285">
                    <Phone className="w-5 h-5 text-cg-orange-600" data-id="element-286" />
                  </div>
                  <div data-id="element-287">
                    <h3 className="text-sm font-bold text-navy-900 uppercase tracking-wider mb-1" data-id="element-288">
                      Phone
                    </h3>
                    <p className="text-steel-600" data-id="element-289">+44 (0) 1234 567890</p>
                    <p className="text-steel-500 text-sm mt-1" data-id="element-290">
                      Mon–Fri, 09:00–17:00 GMT
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-291">
                  <div className="w-10 h-10 bg-slate-50 border border-steel-200 flex items-center justify-center rounded-sm flex-shrink-0" data-id="element-292">
                    <MapPin className="w-5 h-5 text-cg-orange-600" data-id="element-293" />
                  </div>
                  <div data-id="element-294">
                    <h3 className="text-sm font-bold text-navy-900 uppercase tracking-wider mb-1" data-id="element-295">
                      Head Office
                    </h3>
                    <p className="text-steel-600" data-id="element-296">
                      Unit 12, Industrial Park
                      <br data-id="element-297" />
                      Hertfordshire
                      <br data-id="element-298" />
                      United Kingdom
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-12 p-6 bg-navy-900 rounded-sm text-white" data-id="element-299">
                <h3 className="font-bold mb-2 flex items-center gap-2" data-id="element-300">
                  <Lock className="w-4 h-4 text-cg-orange-600" data-id="element-301" /> Secure &amp;
                  Confidential
                </h3>
                <p className="text-sm text-steel-300 leading-relaxed" data-id="element-302">
                  All enquiries submitted through this form are transmitted via
                  encrypted channels and treated in strict confidence. Your
                  information will not be shared with third parties.
                </p>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-2" data-id="element-303">
              {!submitted ? <form onSubmit={handleSubmit} className="bg-slate-50 p-6 sm:p-8 md:p-10 border border-steel-200 rounded-sm space-y-10" data-id="element-304">
                  <div data-id="element-305">
                    <h2 className="text-2xl font-bold text-navy-900 mb-4" data-id="element-306">
                      Send an Enquiry
                    </h2>
                    <p className="text-steel-600" data-id="element-307">
                      Complete the form below and we'll get back to you
                      promptly.
                    </p>
                  </div>

                  {/* Section A: Contact Details */}
                  <div data-id="element-308">
                    <h3 className="text-sm font-bold text-navy-900 uppercase tracking-wider mb-4 border-b border-steel-200 pb-2" data-id="element-309">
                      Contact Details
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-310">
                      <div data-id="element-311">
                        <label htmlFor="firstName" className="block text-sm font-bold text-navy-900 mb-2" data-id="element-312">
                          First Name *
                        </label>
                        <input type="text" id="firstName" required className="w-full bg-white border border-steel-300 rounded-sm px-4 py-3 text-navy-900 focus:outline-none focus:border-cg-orange-600" value={formData.firstName} onChange={handleChange} data-id="element-313" />
                      </div>
                      <div data-id="element-314">
                        <label htmlFor="lastName" className="block text-sm font-bold text-navy-900 mb-2" data-id="element-315">
                          Last Name *
                        </label>
                        <input type="text" id="lastName" required className="w-full bg-white border border-steel-300 rounded-sm px-4 py-3 text-navy-900 focus:outline-none focus:border-cg-orange-600" value={formData.lastName} onChange={handleChange} data-id="element-316" />
                      </div>
                      <div data-id="element-317">
                        <label htmlFor="email" className="block text-sm font-bold text-navy-900 mb-2" data-id="element-318">
                          Work Email *
                        </label>
                        <input type="email" id="email" required className="w-full bg-white border border-steel-300 rounded-sm px-4 py-3 text-navy-900 focus:outline-none focus:border-cg-orange-600" value={formData.email} onChange={handleChange} data-id="element-319" />
                      </div>
                      <div data-id="element-320">
                        <label htmlFor="phone" className="block text-sm font-bold text-navy-900 mb-2" data-id="element-321">
                          Telephone
                        </label>
                        <input type="tel" id="phone" className="w-full bg-white border border-steel-300 rounded-sm px-4 py-3 text-navy-900 focus:outline-none focus:border-cg-orange-600" value={formData.phone} onChange={handleChange} data-id="element-322" />
                      </div>
                      <div className="md:col-span-2" data-id="element-323">
                        <label htmlFor="jobTitle" className="block text-sm font-bold text-navy-900 mb-2" data-id="element-324">
                          Job Title
                        </label>
                        <input type="text" id="jobTitle" className="w-full bg-white border border-steel-300 rounded-sm px-4 py-3 text-navy-900 focus:outline-none focus:border-cg-orange-600" value={formData.jobTitle} onChange={handleChange} data-id="element-325" />
                      </div>
                    </div>
                  </div>

                  {/* Section B: Organisation Details */}
                  <div data-id="element-326">
                    <h3 className="text-sm font-bold text-navy-900 uppercase tracking-wider mb-4 border-b border-steel-200 pb-2" data-id="element-327">
                      Organisation Details
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-328">
                      <div className="md:col-span-2" data-id="element-329">
                        <label htmlFor="orgName" className="block text-sm font-bold text-navy-900 mb-2" data-id="element-330">
                          Organisation Name *
                        </label>
                        <input type="text" id="orgName" required className="w-full bg-white border border-steel-300 rounded-sm px-4 py-3 text-navy-900 focus:outline-none focus:border-cg-orange-600" value={formData.orgName} onChange={handleChange} data-id="element-331" />
                      </div>
                      <div data-id="element-332">
                        <FormSelect id="orgType" label="Organisation Type" required value={formData.orgType} onChange={handleChange} data-id="element-333">
                          <option value="" data-id="element-334">Select Type</option>
                          <option value="Public sector buyer" data-id="element-335">
                            Public sector buyer
                          </option>
                          <option value="Defence buyer" data-id="element-336">Defence buyer</option>
                          <option value="Police force" data-id="element-337">Police force</option>
                          <option value="Custodial/prison service" data-id="element-338">
                            Custodial/prison service
                          </option>
                          <option value="Medical/NGO procurement" data-id="element-339">
                            Medical/NGO procurement
                          </option>
                          <option value="Private sector" data-id="element-340">Private sector</option>
                          <option value="Distributor" data-id="element-341">Distributor</option>
                          <option value="Other" data-id="element-342">Other</option>
                        </FormSelect>
                      </div>
                      <div data-id="element-343">
                        <label htmlFor="country" className="block text-sm font-bold text-navy-900 mb-2" data-id="element-344">
                          Country *
                        </label>
                        <input type="text" id="country" required className="w-full bg-white border border-steel-300 rounded-sm px-4 py-3 text-navy-900 focus:outline-none focus:border-cg-orange-600" value={formData.country} onChange={handleChange} data-id="element-345" />
                      </div>
                      <div data-id="element-346">
                        <label htmlFor="city" className="block text-sm font-bold text-navy-900 mb-2" data-id="element-347">
                          City
                        </label>
                        <input type="text" id="city" className="w-full bg-white border border-steel-300 rounded-sm px-4 py-3 text-navy-900 focus:outline-none focus:border-cg-orange-600" value={formData.city} onChange={handleChange} data-id="element-348" />
                      </div>
                    </div>
                  </div>

                  {/* Section C: Order Details */}
                  <div data-id="element-349">
                    <h3 className="text-sm font-bold text-navy-900 uppercase tracking-wider mb-4 border-b border-steel-200 pb-2" data-id="element-350">
                      Order Details
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-351">
                      <div data-id="element-352">
                        <FormSelect id="enquiryType" label="Enquiry Type" required value={formData.enquiryType} onChange={handleChange} data-id="element-353">
                          <option value="" data-id="element-354">Select Type</option>
                          <option value="Product enquiry" data-id="element-355">
                            Product enquiry
                          </option>
                          <option value="Order request" data-id="element-356">Order request</option>
                          <option value="Bulk procurement" data-id="element-357">
                            Bulk procurement
                          </option>
                          <option value="Availability check" data-id="element-358">
                            Availability check
                          </option>
                          <option value="General enquiry" data-id="element-359">
                            General enquiry
                          </option>
                        </FormSelect>
                      </div>
                      <div data-id="element-360">
                        <FormSelect id="productCategory" label="Product Category" value={formData.productCategory} onChange={handleChange} data-id="element-361">
                          <option value="" data-id="element-362">Select Category (Optional)</option>
                          {inventoryCategories.map(cat => <option key={cat.slug} value={cat.name} data-id="element-363">
                              {cat.name}
                            </option>)}
                          <option value="Other" data-id="element-364">Other</option>
                        </FormSelect>
                      </div>
                      <div data-id="element-365">
                        <FormSelect id="quantity" label="Quantity / Scale" value={formData.quantity} onChange={handleChange} data-id="element-366">
                          <option value="" data-id="element-367">Select Scale (Optional)</option>
                          <option value="Single item" data-id="element-368">Single item</option>
                          <option value="Small batch" data-id="element-369">Small batch</option>
                          <option value="Ongoing supply" data-id="element-370">Ongoing supply</option>
                          <option value="Large procurement" data-id="element-371">
                            Large procurement
                          </option>
                        </FormSelect>
                      </div>
                      <div data-id="element-372">
                        <FormSelect id="timescale" label="Timescale" value={formData.timescale} onChange={handleChange} data-id="element-373">
                          <option value="" data-id="element-374">Select Timescale (Optional)</option>
                          <option value="Immediate" data-id="element-375">Immediate</option>
                          <option value="1 to 4 weeks" data-id="element-376">1 to 4 weeks</option>
                          <option value="1 to 3 months" data-id="element-377">1 to 3 months</option>
                          <option value="3 or more months" data-id="element-378">
                            3 or more months
                          </option>
                        </FormSelect>
                      </div>
                    </div>
                  </div>

                  {/* Section D: Message */}
                  <div data-id="element-379">
                    <h3 className="text-sm font-bold text-navy-900 uppercase tracking-wider mb-4 border-b border-steel-200 pb-2" data-id="element-380">
                      Message
                    </h3>
                    <div data-id="element-381">
                      <label htmlFor="message" className="block text-sm font-bold text-navy-900 mb-2" data-id="element-382">
                        Message / Requirements *
                      </label>
                      <textarea id="message" required rows={5} className="w-full bg-white border border-steel-300 rounded-sm px-4 py-3 text-navy-900 focus:outline-none focus:border-cg-orange-600" placeholder="Please include product details, specifications, quantity, delivery region, and any other requirements..." value={formData.message} onChange={handleChange} data-id="element-383" />
                    </div>
                  </div>

                  <button type="submit" className="w-full bg-cg-orange-600 hover:bg-cg-orange-500 text-white font-bold uppercase tracking-wider py-4 rounded-sm transition-colors" data-id="element-384">
                    Submit Enquiry
                  </button>

                  <div className="flex items-start gap-2 bg-white border border-steel-200 rounded-sm p-3" data-id="element-385">
                    <Lock className="w-3.5 h-3.5 text-cg-orange-600 mt-0.5 flex-shrink-0" data-id="element-386" />
                    <p className="text-xs text-steel-500 leading-relaxed" data-id="element-387">
                      This form is encrypted and all submissions are treated in
                      strict confidence. Your data is processed in accordance
                      with our{' '}
                      <Link to="/privacy-policy" className="underline hover:text-cg-orange-600" data-id="element-388">
                        Privacy Policy
                      </Link>{' '}
                      and{' '}
                      <Link to="/terms-of-service" className="underline hover:text-cg-orange-600" data-id="element-389">
                        Terms of Service
                      </Link>
                      .
                    </p>
                  </div>
                </form> : <div className="bg-green-50 border border-green-200 p-12 rounded-sm text-center h-full flex flex-col items-center justify-center" data-id="element-390">
                  <CheckCircle2 className="w-16 h-16 text-green-600 mb-6" data-id="element-391" />
                  <h3 className="text-2xl font-bold text-navy-900 mb-4" data-id="element-392">
                    Thank you. Your enquiry has been received.
                  </h3>
                  <p className="text-steel-700 mb-8 max-w-md mx-auto" data-id="element-393">
                    We will review your requirements and be in touch shortly.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4" data-id="element-394">
                    <Link to="/" className="px-6 py-3 bg-navy-900 text-white font-bold uppercase tracking-wider text-sm rounded-sm hover:bg-navy-800 transition-colors" data-id="element-395">
                      Browse Inventory
                    </Link>
                    <button onClick={() => setSubmitted(false)} className="px-6 py-3 bg-white border border-navy-900 text-navy-900 font-bold uppercase tracking-wider text-sm rounded-sm hover:bg-slate-50 transition-colors" data-id="element-396">
                      Submit Another Enquiry
                    </button>
                  </div>
                </div>}
            </div>
          </div>
        </div>
      </section>
    </InventoryLayout>;
}